<template>
    <sidebar-left>
        <slot slot="sidebar-left">
            <SideMenu :SideMenuLinks="sideMenuLinks"></SideMenu>
        </slot>
        <slot slot="main">
            <v-loading :data="loaded" type="global"></v-loading>
            <div v-if="!added" class="u-max-700 u-center-block">
                <page-header>
                    <slot slot="title">
                        {{ $t('customer.account.addresses.create.title_'+Type) }}
                    </slot>
                    <slot slot="description">
                        <p>{{ $t('customer.account.addresses.create.description') }}</p>
                    </slot>
                </page-header>

                <section class="c-form-row o-page-bottom-spacing--medium">
                    <form action="" class="c-form c-form--horizontal">
                        <v-form-row>
                            <v-input v-model="Address.Name" name="address_name" :fluid="true" :error="Validate.Name">
                                <slot slot="label">{{ $t('customer.account.addresses.form.name.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-custom-select v-model="selectedCountry"
                                         :options="DeliveryCountryOptions"
                                         option-name="content"
                                         option-value="value"
                                         track-by="value"
                                         search-label="content"
                                         name="delivery-address"
                                         :error="Validate.CountryId"
                                         @change="completeAddress">
                                <slot slot="label">{{ $t('customer.account.addresses.form.country.label') }}</slot>
                            </v-custom-select>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Address.ZipCode" name="address_postal_code" :fluid="true" :error="Validate.ZipCode" @blur="completeAddress">
                                <slot slot="label">{{ $t('customer.account.addresses.form.postal_code.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Address.HouseNumber" name="address_house_number" :fluid="true" :error="Validate.Number" @blur="completeAddress">
                                <slot slot="label">{{ $t('customer.account.addresses.form.house_number.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Address.Street" name="address_street" :fluid="true" :error="Validate.Street">
                                <slot slot="label">{{ $t('customer.account.addresses.form.street.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Address.City" name="address_city" :fluid="true" :error="Validate.City">
                                <slot slot="label">{{ $t('customer.account.addresses.form.city.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Address.Email" name="address_mail" :fluid="true" :error="Validate.Email">
                                <slot slot="label">{{ $t('customer.account.addresses.form.mail.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <v-input v-model="Address.Phone" name="address_phone" :fluid="true" :error="Validate.Phone">
                                <slot slot="label">{{ $t('customer.account.addresses.form.phone.label') }}</slot>
                            </v-input>
                        </v-form-row>

                        <v-form-row>
                            <div class="c-form-item c-form-item--horizontal">
                                <v-label></v-label>
                                <button @click.prevent="submitForm" class="c-button c-button--alpha">
                                    {{ $t('customer.account.addresses.create.form.submit') }}
                                </button>
                            </div>
                        </v-form-row>
                    </form>
                </section>
            </div>
            <div v-else class="u-max-700 u-center-block">
                <page-header>
                    <slot slot="title">
                        {{$t('customer.account.addresses.create.success')}}
                    </slot>
                    <slot slot="description">
                        <p>
                            {{$t('customer.account.addresses.create.success_description')}}
                        </p>
                        <p>
                            <router-link class="c-button c-button--neutral" :to="{name:'CustomerAccountAddresses'}">
                                {{$t('customer.account.addresses.create.back_to_my_addresses')}}
                            </router-link>
                        </p>
                    </slot>
                </page-header>
            </div>
        </slot>
    </sidebar-left>

</template>

<script>
    import VLoading from '@/components/Loading'
    import VTextarea from '@/components/form/Textarea'
    import VInput from '@/components/form/Input'
    import VSelect from '@/components/form/Select'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VFormRow from '@/components/form/Row'
    import VLabel from '@/components/form/Label'
    import PageHeader from '@/components/common/PageHeader'
    import SideMenu from '@/components/common/SideMenu'
    import SidebarLeft from '@/components/layout/SidebarLeft'

    export default {
        components: {
            VLoading,
            PageHeader,
            SideMenu,
            SidebarLeft,
            VTextarea,
            VSelect,
            VCustomSelect,
            VLabel,
            VInput,
            VFormRow
        },
        data() {
            return {
                Type: this.$route.params.type,
                Address: {
                    Name: '',
                    Street: '',
                    ZipCode: '',
                    City: '',
                    CountryName: '',
                    CountryId: '',
                    Email: '',
                    Phone: '',
                    Type: this.$route.params.type
                },
                Validate: {},
                loaded: { isLoaded: true },
                added: false
            }
        },
        created() {
            this.$store.dispatch('getAvailableCountryOptions');
        },
        computed: {
            customerKey() {
                return parseInt(this.$store.getters.userInfo.customerKey);
            },
            DeliveryCountryOptions() {
                return this.$store.getters.AvailableCountryOptions;
            },
            selectedCountry: {
                get () {
                    let output;
                    output = this.DeliveryCountryOptions.find((obj) => {
                        return obj.value === this.Address.CountryName;
                    });

                    if (output) {
                        this.$set(this.Address, 'CountryName', output.value);
                        this.$set(this.Address, 'CountryId', output.code);
                    }

                    return output ? output : {};
                },
                set (value) {
                    this.$set(this.Address, 'CountryName', value.value);
                    this.$set(this.Address, 'CountryId', value.code);
                    return value;
                }
            },
          sideMenuLinks() {
            let menu = [
              {
                title: 'customer.account.edit.title',
                route: '/customer/account/edit',
              }
            ];

            if(this.isCustomer) {
              menu.push({
                title: 'customer.account.users.title',
                route: '/customer/account/users'
              });
              menu.push({
                title: 'customer.account.addresses.title',
                route: '/customer/account/addresses'
              });
            }

            if(this.isCustomer || this.isMarketing) {
              menu.push({
                title: 'customer.account.history.title',
                route: '/customer/account/history'
              });

              menu.push({
                title: 'customer.account.backorders.title',
                route: '/customer/account/backorders'
              })
            }

            if(this.isCustomer) {
              menu.push({
                title: 'customer.account.invoices.title',
                route: '/customer/account/invoices'
              });
            }

            return menu;
          },
          isCustomer() {
            return this.$store.getters.isCustomer;
          },
          isPersoneel() {
            return this.$store.getters.isPersoneel;
          },
          isMarketing() {
            return this.$store.getters.isMarketing;
          },
        },
        methods: {
            submitForm() {
                this.loaded = {};
                this.$store.dispatch('sendAddress', {
                    customer: this.customerKey,
                    body: this.Address
                }).then((response) => {
                    if (response.status > 300 && response.data.ModelState) {
                        this.setValidation(response.data.ModelState);
                        this.loaded = { isLoaded: true };
                    } else {
                        this.notifyUser(this.$t('customer.account.addresses.delete.notification.title'), 'success');
                        this.added = true;
                        this.Validate = {};
                        this.loaded = { isLoaded: true };
                    }
                }).catch(() => {
                    this.loaded = { isLoaded: true };
                });
            },

            completeAddress() {
                if((this.selectedCountry && this.selectedCountry.code == "NL")
                && (this.Address.ZipCode && this.Address.ZipCode.length > 0)
                && (this.Address.HouseNumber && this.Address.HouseNumber.length > 0))
                {
                    //Do call to maybe autocomplete street
                    this.$store.dispatch('getStreet', { postalCode: this.Address.ZipCode, houseNr: this.Address.HouseNumber }).then((response) => {
                        this.Address.Street = response.street;
                    });
                }
            },
            // NOTIFY USER
            notifyUser(title, type = 'success') {
                this.$notify({
                    group: 'global',
                    title: title,
                    type: type,
                    duration: 2000
                });
            },

            // SET VALIDATION
            setValidation(errors) {
                Object.keys(errors).forEach(function (key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.' + key][0];
                    delete errors['model.' + key];
                });

                this.Validate = errors;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .add-address {
        padding: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        color: $color-alpha;
        border: solid 1px;
    }

    .u-m--15 {
        margin: -15px;
    }

    .u-p-15 {
        padding: 15px !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/customer/account/AddressesCreate.vue